import React, { useCallback } from 'react';

import { useUserContext } from 'providers/UserProvider';

import Table from 'components/common/Table';

import { inventoryApi, productApi } from 'api';

import {
  INVENTORY_HISTORY_LIST_COLUMNS,
  INVENTORY_HISTORY_FILTER_OPTIONS,
} from 'constants/inventory';

const InventoryHistory = () => {
  const { selectedWarehouse } = useUserContext();
  const initialFilter = {
    warehouse: selectedWarehouse?.id,
    inventory_history_method: ['increase', 'force_update', 'decrease'],
  };

  const exportApi = useCallback(params => {
    return inventoryApi.getInventoryHistoryExport(params);
  }, []);

  return (
    <Table
      title="Inventory History"
      apiService={inventoryApi}
      exportApi={exportApi}
      sortable={true}
      columns={INVENTORY_HISTORY_LIST_COLUMNS}
      filterOptions={INVENTORY_HISTORY_FILTER_OPTIONS}
      initialPageSize={50}
      initialFilter={initialFilter}
      fetchConfig={{
        method: 'getInventoryHistoryList',
      }}
    />
  );
};

export default InventoryHistory;
